export class Story {
  public stitchesArray: Array<Stitch>;
  public initial: string;
  public title: string;
  public flags: Flags;
  public effects: Effects;
  public lang: number; // 0: français, 1: anglais
  constructor(datas: any, effects: any, lang:number) {
    this.init(datas, effects, lang);
  }
  public init(datas: any, effects: any, lang:number): void {
    console.log(datas);
    this.lang = lang;
    this.stitchesArray = this.getStitches(datas);
    this.title = datas.title.replace(/_/g, '<br>');
    this.initial = datas.data.initial;
    this.flags = new Flags();

    let firstStitch = this.stitchesArray.find(stitch => stitch.path == this.initial);
    if (firstStitch) {
      firstStitch.flagNames.push('init')
    }

    this.effects = new Effects(effects);
  }
  private getStitches(datas: any): Array<Stitch> {
    return Object.keys(datas.data.stitches).map((stichName) => {
      return new Stitch(stichName, datas.data.stitches[stichName].content, this.lang);
    });
  }
  public getStitch(path: string, join: boolean = true): Stitch {
    let stitch: Stitch = (this.stitchesArray.find(stitch => stitch.path == path) as Stitch);
    stitch.process(this.flags);
    let text:string = stitch.text;
    let divert:string = stitch.divert;
    let choices: Array<Choice> = stitch.choices;
    while (divert) {
      let divertStitch:Stitch = (this.stitchesArray.find(s => s.path == divert) as Stitch);
      divertStitch.process(this.flags);
      text += divertStitch.text;
      divert = divertStitch.divert;
      choices = divertStitch.choices;
    }
    stitch.text = text;
    stitch.choices = choices;
    return stitch;
  }

  // public getStitch_OLD(path: string, join: boolean = true): Stitch {
  //   let virtualStitch: Stitch = (this.stitchesArray.find(stitch => stitch.path == path) as Stitch);
  //   virtualStitch.process(this.flags);
  //   if (join) {
  //     while (virtualStitch.divert) {
  //       virtualStitch.virtual = true;
  //       let divertStitch: Stitch = this.getStitch(virtualStitch.divert);
  //       divertStitch.process(this.flags);
  //       // virtualStitch.text_raw += divertStitch.text_raw;
  //       virtualStitch.text += divertStitch.text;
  //       virtualStitch.divert = divertStitch.divert;
  //       virtualStitch.choices = divertStitch.choices;
  //     }
  //   }
  //   return virtualStitch;
  // }

  public updateFlags(stitch: Stitch): void {
    // Read flagNames
    this.unsetFlagsEffects();
    stitch.flagNames.forEach(flagName => {
      let initilization = flagName.match(/^(.*)=(.*)$/g);
      let operation = flagName.match(/^(.*)[\-+*/](.*)$/g);
      let flag = flagName.match(/^[a-z0-9_]+$/gi);
      if (initilization) {
        let arr = flagName.split('=').map(elt => elt.trim());
        let label: string = arr[0];
        let value: string = arr[1];
        if ('' + parseInt(value) == value) {
          this.flags.set(label, parseInt(value));
        } else {
          this.flags.set(label, value);
        }
      } else if (operation) {
        let matches: Array<string> = flagName.match(/^[a-z0-9_]+/gi);
        if (matches) {
          matches = matches.map(elt => elt.trim());
          let label: string = matches[0].trim();
          let operation2: string = flagName.substring(label.length).trim();
          this.flags.calculate(label, operation2);
        } else {
          console.log('problem with stitch flagNames', stitch.flagNames);
        }
      } else if (flag) {
        this.flags.set(flagName, true);
      }
    });
  }
  unsetFlagsEffects(): void {
    this.flags.unset(this.effects.effects.map((effect) => effect.id));
  }
}

export class Stitch {
  public path: string;
  public linkPath: number;
  public flagNames: Array<string>
  public text_raw: string;
  public text: string;
  public choices: Array<Choice>;
  public image: string;
  public pageNum: number;
  public divert: string;
  public ifConditions: Conditions;
  public notIfConditions: Conditions;
  public virtual: boolean = false;
  public pageLabel: string;
  public lang: number; // 0: français, 1: anglais

  constructor(path: string, content: Array<any>, lang:number) {
    this.init(path, content, lang);
  }
  public init(path: string, content: Array<any>, lang:number) {
    this.lang = lang;
    this.path = path;
    this.text_raw = content.find((elt) => typeof elt == 'string');

    // if (this.text_raw && this.text_raw.length/4.8 > 50){
    //   console.log(this.text_raw, '(', this.text_raw.split(' ').length, 'mots)');
    //   console.log(' ');
    // }

    this.text_raw = '<p>' + this.text_raw + '</p>';

    let arg = content.filter((elt) => elt.option && elt.option != '');
    this.choices = arg.map((choice) => new Choice(choice));

    // this.choices.forEach((choice) => {
    //   if (choice.ifConditions.conditions.length || choice.ifConditions.conditions.length) {
    //     console.log(this.path, ':');
    //   }
    //   if (choice.ifConditions.conditions.length) {
    //     choice.ifConditions.conditions.forEach(condition => {
    //       console.log('"' + condition.text + '"');
    //     });
    //   }
    //   if (choice.notIfConditions.conditions.length) {
    //     choice.notIfConditions.conditions.forEach(condition => {
    //       console.log('"' + condition.text + '"');
    //     });
    //   }
    // });

    let pageNum = content.find((elt) => elt.pageNum && elt.pageNum != '');
    if (pageNum) {
      this.pageNum = pageNum.pageNum;
    }
    let divert = content.find((elt) => elt.divert && elt.divert != '');
    if (divert) {
      this.divert = divert.divert;
    }

    let pageLabel = content.find((elt) => elt.pageLabel && elt.pageLabel != '');
    if (pageLabel) {
      this.pageLabel = pageLabel.pageLabel;
    }

    this.ifConditions = new Conditions(content.filter((elt) => elt.ifCondition && elt.ifCondition != '').map(elt => elt.ifCondition));
    this.notIfConditions = new Conditions(content.filter((elt) => elt.notIfCondition && elt.notIfCondition != '').map(elt => elt.notIfCondition));

    // if (this.ifConditions.conditions.length || this.ifConditions.conditions.length) {
    //   console.log(this.path);
    // }
    // if (this.ifConditions.conditions.length) {
    //   this.ifConditions.conditions.forEach(condition => {
    //     console.log('"' + condition.text + '"');
    //   });
    // }
    // if (this.notIfConditions.conditions.length) {
    //   console.log('not');
    //   this.notIfConditions.conditions.forEach(condition => {
    //     console.log('"' + condition.text + '"');
    //   });
    // }

    let image = content.find((elt) => elt.image && elt.image != '');
    if (image) {
      this.image = image.image;
    }
    this.flagNames = [];
    let flagNameNodes: Array<any> = content.filter((elt) => elt.flagName && elt.flagName != '');
    flagNameNodes.forEach((flagNameNode) => this.flagNames = [...this.flagNames, ...flagNameNode.flagName.split(' ')]);
    // if (this.flagNames.length) {
    //   console.log(this.path, this.flagNames);
    // }
    this.process();
  }
  public process(flags: Flags = new Flags()): void {
    if (this.virtual) return;

    // let text = '';
    let text: string = this.text_raw;
    if (this.ifConditions.check(flags) && this.notIfConditions.check(flags, false)) {
      // Random filter : {~Pierre|Luigi|Suzanne}
      text = text.replace(/\{\~(.*\|{0,1})\}/g, (arg) => {
        let label = arg;
        let flag = flags.get(label);
        if (!flag) {
          let arr: Array<string> = arg.substring(2, arg.length - 1).split('|').map(elt => elt.trim());
          let value = arr[Math.floor(arr.length * Math.random())];
          flag = flags.set(label, value);
        }
        return flag.value;
      });

      // {woman:Madame|Monsieur}
      text = text.replace(/\{([^\}]*):([^\}]*)\|([^\}]*)\}/g, (arg) => {
        let arr = arg.match(/\{(.*):(.*)\|(.*)\}/);
        arr = arr.map(str => str.trim());
        let label = arr[1];
        let flag = flags.get(label);
        let ret: string = '';
        if (flag) {
          ret = arr[2];
        } else {
          ret = arr[3];
        }
        return ret;
      });

      // add br
      text = text.replace(/_/g, '<br>');
      // add no wraping spaces
      if (this.lang == 0){
        text = text.replace(/\s*[?]/g, '&#8239;?');
        text = text.replace(/\s*[!]/g, '&#8239;!');
        text = text.replace(/\s*[:]/g, '&nbsp;:');
        text = text.replace(/M\.\s*/g, 'M.&nbsp;');
      } else if (this.lang == 1){
        text = text.replace(/\s*[?]/g, '?');
        text = text.replace(/\s*[!]/g, '!');
        text = text.replace(/\s*[:]/g, ':');
      }

      // add em
      text = text.replace(/\/=/g, '<em>');
      text = text.replace(/=\//g, '</em>');
      // add strong
      text = text.replace(/\*-/g, '<strong>');
      text = text.replace(/-\*/g, '</strong>');
      // add guillemets
      if (this.lang == 0){
        text = text.replace(/«\s*/g, '«&#8239;');
        text = text.replace(/\s*»/g, '&#8239;»');
      } else if (this.lang == 1){
        text = text.replace(/«\s*/g, '“');
        text = text.replace(/\s*»/g, '”');
      }
      let name = flags.get('nom');
      if (name) {
        // rename Louise & Paul & cie
        if (name.value == 'Louise') {
          text = text.replace(/Louise/g, 'Marie');
        }
        if (name.value == 'Paul') {
          text = text.replace(/Paul/g, 'Jacques');
        }
        if (name.value == 'Marc') {
          text = text.replace(/Marc/g, 'Nicolas');
        }
        if (name.value == 'Josephine') {
          text = text.replace(/Joséphine/g, 'Géraldine');
        }
        if (name.value == 'Sam') {
          text = text.replace(/Sam/g, 'Tom');
        }
        if (name.value == 'Anna') {
          text = text.replace(/Anna/g, 'Carole');
        }
        if (name.value == 'Thomas') {
          text = text.replace(/Thomas/g, 'Alexis');
        }
        // add name
        text = text.replace(/\{nom\}/g, flags.get('nom').value);
      }
    }
    this.choices.forEach(choice => choice.check(flags));
    this.text = text;
  }
  hasFlag(flagName: string): boolean {
    return this.flagNames.indexOf(flagName) != -1;
  }
  isMenu(): boolean {
    let flagName: string = this.flagNames.find((flag => flag.substring(0, 5) == 'menu_'));
    return !!flagName;
  }
  getMenu(): string {
    let ret = '';
    let flagName: string = this.flagNames.find((flag => flag.substring(0, 5) == 'menu_'));
    if (flagName) {
      let tab = flagName.split('_');
      tab.shift();
      ret = 'Accès : ' + tab.join(' ');
    }
    return ret;
  }
}

export class Choice {
  public option: string;
  public linkPath: string;
  public ifConditions: Conditions;
  public notIfConditions: Conditions;
  public active: boolean;

  constructor(choice: any) {
    this.init(choice);
  }
  init(choice: any) {
    this.option = choice.option;
    this.linkPath = choice.linkPath;

    let arr: Array<any>;
    if (!choice.ifConditions) {
      this.ifConditions = new Conditions();
    } else {
      arr = choice.ifConditions;
      this.ifConditions = new Conditions(arr.map(elt => elt.ifCondition));
    }

    if (!choice.notIfConditions) {
      this.notIfConditions = new Conditions();
    } else {
      arr = choice.notIfConditions;
      this.notIfConditions = new Conditions(arr.map(elt => elt.notIfCondition));
    }

    this.check();
  }
  public check(flags: Flags = new Flags()): void {
    this.active = this.ifConditions.check(flags) && this.notIfConditions.check(flags, false);
  }
}

export class Flags {
  flags: Array<Flag>;
  constructor() {
    this.init();
  }
  init() {
    this.flags = [];
  }
  public get(label: string): any {
    let flag = this.flags.find(flag => flag.label == label);
    return flag;
  }
  public set(label: string, value: any): Flag {
    if (label == 'nom'){
      console.log(label, value);
    }
    let flag = this.flags.find(flag => flag.label == label);
    if (!flag) {
      flag = new Flag(label, value);
      this.flags.push(flag);
    } else {
      flag.value = value;
    }
    if (label == 'nom'){
      console.log(label, flag);
    }
    return flag;
  }
  public unset(arr: Array<string>): void {
    console.log('avant', this.flags.map((flag) => flag.label));
    this.flags = this.flags.filter((flag) => arr.indexOf(flag.label) == -1);
    console.log('apres', this.flags.map((flag) => flag.label));
  }
  public calculate(label: string, operation: any): void {
    let flag = this.flags.find(flag => flag.label == label);
    if (flag) {
      flag.value = eval(flag.value + operation);
    }
  }
}

export class Flag {
  constructor(
    public label: string,
    public value: any
  ) { }
}

export class Conditions {
  conditions: Array<Condition>;
  constructor(conditions: Array<string> = []) {
    this.init(conditions);
  }
  init(conditions: Array<string> = []) {
    this.conditions = conditions.map(condition => new Condition(condition));
  }
  public check(flags: Flags, bool: boolean = true): boolean {
    let ret = this.conditions.reduce(
      (accumutalor, condition) => {
        return accumutalor && (condition.check(flags) == bool);
      }
      , true) == true;
    return ret;
  }
}

export class Condition {
  public text: string;
  public label: string;
  public operator: string;
  public value: any;
  public valueType: string;
  constructor(condition: string) {
    this.init(condition);
  }
  public init(condition: string = null) {
    this.text = condition;
    let comparison = condition.match(/^(.*)[=><]+(.*)$/g);
    let existence = condition.match(/^[a-z0-9_]+$/gi);
    if (comparison) {
      let matches: Array<string>;
      matches = condition.match(/^[a-z0-9_]+/gi);
      this.label = matches[0].trim();

      matches = condition.match(/[=><]+/gi);

      this.operator = matches[0].trim();
      this.operator = this.operator.replace(/^=+/g, '==');

      matches = condition.match(/[a-z0-9_]+$/gi);
      let value = matches[0].trim();

      if (isNaN(parseInt(value))) {
        this.valueType = 'string';
        this.value = value;
      } else {
        this.valueType = 'number';
        this.value = parseInt(value);
      }
    } else if (existence) {
      this.label = condition;
      this.operator = '==';
      this.value = true;
      this.valueType = 'boolean';
    } else {
      console.log('if ou ifNot Condition syntax error', condition);
    }
  }
  public check(flags: Flags): boolean {
    let res = false;
    let currentFlag = flags.get(this.label);
    if (currentFlag) {
      let currentValue = currentFlag.value;
      if (this.valueType == 'string') {
        try {
          res = eval('"' + currentValue + '"' + this.operator + '"' + this.value + '"');
        } catch (e) {
          console.log(currentValue, this.operator, this.value);
          console.log('eval try catch error', e);
        }
      } else {
        try {
          res = eval(currentValue + this.operator + this.value);
        } catch (e) {
          console.log(currentValue, this.operator, this.value);
          console.log('eval try catch error', e);
        }
      }
    }
    return res;
  }
}

export class Effects {
  public effects: Array<Effect>;
  constructor(datas: any) {
    this.init(datas);
  }
  public init(datas: any): void {
    this.effects = datas;
  }
  public getEffect(id: string): Effect {
    return (this.effects.find(effect => effect.id == id) as Effect);
  }
  public findEffect(matchingFunction: (effect: any) => boolean): Effect {
    let ret: Effect = (this.effects.find(effect => matchingFunction(effect)) as Effect);
    if (!ret) {
      console.error('Effet inconnu', matchingFunction);
    }
    return ret;
  }
  public filterEffect(matchingFunction: (effect: any) => boolean): Array<Effect> {
    return this.effects.filter(effect => matchingFunction(effect));
  }
  public getFirstEffect(): Effect {
    return this.findEffect(effect => effect.id && effect.id == 'init');
  }
}

export class Effect {
  id: string;
  choice: string;
  image: string;
  map: string;
  sound: string;
  speed: number;
  amplitude: number;
  disorder: number;
  camera: Camera;
  camera_mvt: Camera;
  filter: string;
  effects: Array<string>;
}

export class Camera {
  px: number = 0;
  py: number = 0;
  pz: number = 0;
  rx: number = 0;
  ry: number = 0;
  rz: number = 0;

  constructor(values: any = {}) {
    this.init(values);
  }
  public init(values: any): void {
    Object.keys(this)
      .forEach(key => {
        let val: any = values[key as keyof Camera];
        if (val != undefined){
          this[key as keyof Camera] = val;
        }
      });
  }
  public add(cameraMvt: Camera): Camera {
    let px = this.px + cameraMvt.px;
    let py = this.py + cameraMvt.py;
    let pz = this.pz + cameraMvt.pz;
    let rx = this.rx + cameraMvt.rx;
    let ry = this.ry + cameraMvt.ry;
    let rz = this.rz + cameraMvt.rz;
    return new Camera({ px: px, py: py, pz: pz, rx: rx, ry: ry, rz: rz });
  }
  public interpolate(targetCamera: Camera, acc: number): Camera {
    let px = this.interpolateNumber(targetCamera.px, this.px, acc);
    let py = this.interpolateNumber(targetCamera.py, this.py, acc);
    let pz = this.interpolateNumber(targetCamera.pz, this.pz, acc);
    let rx = this.interpolateNumber(targetCamera.rx, this.rx, acc);
    let ry = this.interpolateNumber(targetCamera.ry, this.ry, acc);
    let rz = this.interpolateNumber(targetCamera.rz, this.rz, acc);
    return new Camera({ px: px, py: py, pz: pz, rx: rx, ry: ry, rz: rz });
  }
  private interpolateNumber(target: number, pos: number, acc: number): number {
    return (target + pos * acc) / (1 + acc);
  }
  public clone(targetCamera: Camera, acc: number): Camera {
    let newCam = new Camera();
    Object.keys(this)
      .forEach(key => {
        let target: any = targetCamera[key as keyof Camera];
        newCam[key as keyof Camera] = target;
      });
    return newCam;
  }
}

